exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".card{border:1px solid #bfd0d9;border-radius:10px;margin-bottom:20px;padding:10px}.description{margin-left:10px}.title{margin-bottom:0}.subtitle{font-size:12px}.separator{margin:10px -10px}.content{padding:0 10px}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/shared/card/card.component.css"],"names":[],"mappings":"AAAA,MACE,yBAA0B,mBACN,mBACA,YACN,CACf,aAKC,gBAAkB,CACnB,OAGC,eAAiB,CAClB,UAGC,cAAgB,CACjB,WAOC,iBAAmB,CACpB,SAGC,cAAgB,CACjB","file":"card.component.css","sourcesContent":[".card{\n  border: 1px solid #bfd0d9;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  padding: 10px;\n}\n\n.headling{}\n\n.description{\n  margin-left: 10px;\n}\n\n.title{\n  margin-bottom: 0;\n}\n\n.subtitle{\n  font-size: 12px;\n}\n\n.ico{\n\n}\n\n.separator{\n  margin: 10px -10px;\n}\n\n.content{\n  padding: 0 10px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/card/card.component.css
// module id = j9el
// module chunks = 6